<script setup>
import {APIService} from '@ohrm/core/util/services/api.service';
import {defineProps} from 'vue';

const props = defineProps({
  params: {
    type: Object,
    default: () => ({}),
  },
  apiPath: {
    type: String,
    default: 'api/training',
  },
});

const http = new APIService(window.appGlobal.baseUrl, props.apiPath);

const loadTrainings = async serachParam => {
  return new Promise(resolve => {
    if (serachParam.trim()) {
      http
        .request({
          params: {
            name: serachParam.trim(),
          },
        })
        .then(({data}) => {
          resolve(
            data.data.map(training => {
              return {
                id: training.id,
                label: training.title,
              };
            }),
          );
        });
    } else {
      resolve([]);
    }
  });
};
</script>

<template>
  <oxd-input-field
    type="autocomplete"
    :label="$t('training.training_title')"
    :clear="false"
    :create-options="loadTrainings"
  >
    <template #option="{data}">
      <span>{{ data.label }}</span>
    </template>
  </oxd-input-field>
</template>

<style scoped>
.past-employee-tag {
  margin-left: auto;
}
</style>
